module.exports = __webpack_public_path__ + "static/media/idea.86166357.svg";